var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAppleIcon = function SvgAppleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9167 15.9667C16.4084 15.2167 16.5917 14.8334 16.9667 13.9917C14.2001 12.9417 13.7584 9.00003 16.4917 7.4917C15.6584 6.4417 14.4834 5.83337 13.3751 5.83337C12.5751 5.83337 12.0251 6.04172 11.5334 6.23338C11.1167 6.39172 10.7417 6.53337 10.2751 6.53337C9.77506 6.53337 9.33339 6.37505 8.86672 6.20838C8.35839 6.02505 7.82505 5.83337 7.15839 5.83337C5.91672 5.83337 4.59172 6.59171 3.75006 7.89171C2.56672 9.72504 2.77506 13.1584 4.68339 16.0917C5.36672 17.1417 6.28339 18.3167 7.47506 18.3334C7.97506 18.3417 8.30005 18.1917 8.65839 18.0334C9.06672 17.8501 9.50839 17.65 10.2834 17.65C11.0584 17.6417 11.4917 17.8501 11.9001 18.0334C12.2501 18.1917 12.5667 18.3417 13.0584 18.3334C14.2667 18.3167 15.2334 17.0167 15.9167 15.9667Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2001 1.66663C13.3334 2.58329 12.9584 3.49164 12.4668 4.12497C11.9418 4.8083 11.0251 5.34162 10.1418 5.30829C9.98345 4.42496 10.3918 3.51662 10.8918 2.90828C11.4501 2.24162 12.3918 1.72496 13.2001 1.66663Z",
    fill: "#292D32"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apple-icon.06f7e3d9.svg";
export { ForwardRef as ReactComponent };